
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { IModel } from "@/types"
import { useModel, modelAtom } from "@/hooks/useChat"
import { useHydrateAtoms } from 'jotai/utils'
import ModelIcon from "./ModelIcon"

export default function ChooseMode({ data, selectedId }: { data: IModel[], selectedId: number }) {

  const [selected, setSelected] = useModel();
  const initData = data.find(item => item.id === selectedId) || data[0]
  useHydrateAtoms([[modelAtom, initData]])
  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className='h-10 bg-white rounded-[10px] border border-[rgba(230,230,230,0.3)] flex items-center  px-1 py-2 cursor-pointer min-w-[120px]'>
            <ModelIcon model={selected!} className='w-6 h-6 rounded-full overflow-hidden mr-2' />
            <div className='text-xs text-[#303133] pr-3'>{selected?.title1}</div>
            <span className='font_family icon-Arrow_Forward text-2xl! text-[#303133] rotate-90 ml-auto'></span>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {
            data.map(item => (
              <DropdownMenuItem key={item.id} onClick={() => setSelected(item)} className={selected?.id === item.id ? "bg-gray-100" : ""}>
                <ModelIcon model={item!} className='w-5 h-5 rounded-full overflow-hidden' />
                <div className="text-xs text-[#303133]">{item.title1}</div>
              </DropdownMenuItem>
            ))
          }
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
